import React from 'react';
import editorStyles from '../QuestionEditor/QuestionEditor.module.css';
import Input from "../../common/Input/Input";
import {useIntl} from "react-intl";

const DateSpecificEditor = () => {
    const intl = useIntl();
    return (
        <div className={editorStyles.inputPlaceholderWrapper}>
            <Input
                type="text"
                placeholder={intl.formatMessage({ id: "question.date_specific" })}
                readOnly disabled />
        </div>
    );
};
export default DateSpecificEditor;
